<template>
  <v-multiselect
    :options="filteredTypeSol"
    :value='$store.state.select.value'
    label='nom'
    @input='setActiveTypeSol'
    placeholder="Sélectionner un type de sol"
  >
    <template slot='noResult'>
      Aucun type de sol correspondant
    </template>
  </v-multiselect>
</template>

<script>
export default {
  name: 'SelectTypeSol',

  props: {
    fromExploitation: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => []
    }
  },

  computed: {

    selectedIds () {
      return this.selected.map(t => t.id_ref_type_sol)
    },

    typeSol () {
      if (this.fromExploitation) {
        return this.$store.getters.getTypeSolExploitation
      }
      return this.$store.getters.getTypeSol
    },

    filteredTypeSol () {
      return this.typeSol.filter(t => !this.selectedIds.includes(t.id_ref_type_sol))
    }
  },

  methods: {
    setActiveTypeSol (typeSol) {
      this.$store.commit('select/SET_VALUE', typeSol)
    }
  }
}
</script>
